/**
 * Some group settings,<br>
 * not implemented yet, for future needs.
 *
 * @category Group Entity
 * */
export class GroupSetting {
  history: null;
}
